var Input = require('./commonjs/InputBasicDefaultMetadata').default

exports = module.exports = Input
exports['default']       = Input